import { Box, VStack } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { ExtensionInstance } from '@mangovoice/types'

import { JumpToSwitchboardNodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { SwitchboardSelector } from '../core/SwitchboardSelector'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useJumpToSwitchboardNode } from './hooks/useJumpToSwitchboardNode'

export interface JumpToSwitchboardNodeProps extends NodeProps {
  extensionMap?: Map<number, ExtensionInstance>
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void
  showDeleteButton?: boolean
  // Note: extensionsList is provided via Jotai atoms (extensionsListAtom)
  // Use useSwitchboardDataAtoms hook in the consuming app to set atoms
}

const JumpToSwitchboardNodeComponent: React.FC<JumpToSwitchboardNodeProps> = ({
  id,
  data,
  extensionMap: _extensionMap, // Reserved for future use
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as JumpToSwitchboardNodeData & Record<string, unknown>
  const { currentSwitchboardId, handleSwitchboardChange, hasData } =
    useJumpToSwitchboardNode(id, nodeData)
  const t = useSwitchboardT()

  return (
    <BaseNode
      label={text(
        t,
        'switchboard.nodeLabels.jump_to_switchboard',
        'JUMP TO SWITCHBOARD',
      )}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
      sourceHandlePosition={null}
    >
      <VStack align="stretch" gap={2}>
        <Box>
          <SwitchboardSelector
            value={currentSwitchboardId}
            onChange={handleSwitchboardChange}
            placeholder={text(
              t,
              'switchboard.core.selectSwitchboard',
              'Select switchboard...',
            )}
          />
        </Box>
      </VStack>
    </BaseNode>
  )
}

export const JumpToSwitchboardNode = React.memo(
  JumpToSwitchboardNodeComponent,
  nodePropsAreEqual,
)
